import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedReembolsosSolicitudComponent {
  autorizando = false
  mostrar = false
  data
  onChange

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    this.inicializar()
  }

  autorizar (data) {
    this.autorizando = false
    if (!data) return

    Object.assign(this.data, data)
    this.inicializar()
    this.onChange({$event: {detail: this.data}})
  }

  eliminar (data) {
    this.eliminando = false
    if (!data.eliminado) return

    this.data = null
    this.onChange({$event: {detail: this.data}})
  }

  inicializar () {
    this.leyenda = this.data.cancelado ? 'Solicitud cancelada' :
      (this.data.pagado && this.data.timbrado ? 'Pago aplicado y timbrado' :
        (this.data.pagado && !this.data.timbrado ? 'Pago aplicado, pendiente de timbrar' :
          (this.data.autorizado ? 'Autorizado, pendiente de pago' : 'En proceso de autorización')))
    this.indice = (this.data.autorizaciones.find((autorizacion) => !autorizacion.autorizado) || {}).indice || null
  }

  finalizar (data) {
    this.maquilando = false
    if (!data.nomina) return

    this.data.id_nomina = data.nomina.id_nomina
    if (data.redireccionar) {
      this.redireccionarNomina()
    }
    this.onChange({$event: {detail: this.data}})
  }

  redireccionarNomina() {
    this.$state.go('nominas.detalladoNomina.colaboradores', {idEmpresa: this.data.id_proyecto, idNomina: this.data.id_nomina})
  }
}

module.component('viaticosSharedReembolsosSolicitud', {
  controller: ViaticosSharedReembolsosSolicitudComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})




// WEBPACK FOOTER //
// ./src/viaticos/components/shared/reembolsos/solicitud/component.js